module.exports = __webpack_public_path__ + "static/img/345.f1ea044.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/news/345.png
// module id = FqDT
// module chunks = 0